import { render } from "./checkout.vue?vue&type=template&id=3d5aa9ea&scoped=true&ts=true"
import script from "./checkout.vue?vue&type=script&lang=ts"
export * from "./checkout.vue?vue&type=script&lang=ts"

import "./checkout.vue?vue&type=style&index=0&id=3d5aa9ea&lang=less&scoped=true"

import exportComponent from "D:\\test\\newDemo\\alp-ui\\vue-component\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d5aa9ea"]])

export default __exports__